import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { PlaceToStayGrabber } from './PlaceToStaySidebar';
import { PLACE_TO_STAY_SCHEMA_URL, PLACE_TO_STAY_COMPONENT_TYPE } from './PlaceToStay.constants';

// Lazy load view components
const PlaceToStayAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorPlaceToStayAdd" */ './PlaceToStaySidebar'), 'PlaceToStayAdd');

const PlaceToStayEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorPlaceToStayEdit" */ './PlaceToStayEdit'), 'PlaceToStayEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const PlaceToStayConfig: AdminJsonComponentConfig = {
  schemaUrl: PLACE_TO_STAY_SCHEMA_URL,
  componentType: PLACE_TO_STAY_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: PlaceToStayAdd,
    dragComponentView: PlaceToStayGrabber,
    editComponentView: PlaceToStayEdit,
    createComponentView: PlaceToStayEdit,
  },
} as const;
